import { render, staticRenderFns } from "./DDDraftPage.vue?vue&type=template&id=461621f7&"
import script from "./DDDraftPage.vue?vue&type=script&lang=js&"
export * from "./DDDraftPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('461621f7')) {
      api.createRecord('461621f7', component.options)
    } else {
      api.reload('461621f7', component.options)
    }
    module.hot.accept("./DDDraftPage.vue?vue&type=template&id=461621f7&", function () {
      api.rerender('461621f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/services/directDebit/DDDraftPage.vue"
export default component.exports